import { useCallback, useEffect } from "react";
import { useTranslation } from "react-i18next";
import AdminLayout from "../../../AdminLayout";
import EmptyContent from "../../../Components/Empty-content/EmptyContent";
import ItemsLoader from "../../../Components/Loader/basic loader/ItemsLoader";
import PaginationComponent from "../../../Components/Pagination";
import TitleBar from "../../../Components/TitleBar";
import { useLoaderStore } from "../../../Store/Loader/LoaderStore";
import { useAbsentStudentsStore } from "../../../Store/ReportsStore/AbsentStudentsStore";
import Heading from "./components/Heading";
import ListItem from "./components/ListItem";

export default function AbsentStudents() {
  const {
    loadItems,
    onReload,
    results,
    pagination,
    queryParams,
    updateParams,
    setLoading,
    isLoading,
    getBranches,
  } = useAbsentStudentsStore();
  const { setLoader } = useLoaderStore();

  const pageLoad = useCallback(async () => {
    setLoader(true);
    await Promise.all([onReload(), getBranches()]);
    setLoader(false);
  }, []);

  useEffect(() => {
    pageLoad();
  }, []);

  const paginateTo = useCallback(
    async (page) => {
      const queryString = new URLSearchParams({
        ...queryParams,
        page: page,
      }).toString();
      setLoading(true);
      updateParams({ page: page });
      await loadItems(queryString);
      setLoading(false);
    },
    [queryParams]
  );
  const { t } = useTranslation();

  return (
    <AdminLayout>
      <TitleBar permission={true} title={t("Dars qoldirgan talabalar")} />
      <div className="container">
        <Heading />
        {isLoading ? (
          <ItemsLoader size={70} />
        ) : results?.length > 0 ? (
          results?.map((item, index) => {
            return <ListItem item={item} index={index} key={index} />;
          })
        ) : (
          <EmptyContent />
        )}
        <PaginationComponent
          context={{ pagination: pagination, queryParams: queryParams }}
          callback={paginateTo}
        />
      </div>
    </AdminLayout>
  );
}
